<template>
  <div class="p-2">
    <v-data-table
      :headers="headers"
      :items="mainlist"
      :search="search"
      fixed-header
      single-line
      height="auto"
      :footer-props="{
        'items-per-page-text': $t('table.item_table'),
        'items-per-page-all-text': $t('table.all'),
        'items-per-page-options': [15, 30, 50, 100],
      }"
      :loading-text="$t('table.loading')"
      :no-data-text="$t('table.no_results_available')"
      :no-results-text="$t('table.no_results_search')"
      dense
    >
    
      <template v-slot:top>
        
        <div class="row justify-end">
           
            <div class="col-md-3">
                              
              <v-autocomplete
                :items="typeProducts"
                v-model="searchtypeProduct"
                clearable
                @change="applyFilter()"
                @input="applyFilter()"
                label="Tipo de producto"
              >
              </v-autocomplete>
            </div> 
            
  
          <div class="col-sm-12 col-md-6 col-lg-5 col-xl-5 text-right">
            <v-text-field
              v-model="search"
              :label="$t('table.search')"
            > <template v-slot:append>
                <span class="pt-2">
                  <i
                    class="feather icon-corner-down-left"
                    v-show="search != ''"
                  >
                  </i>
                </span> </template
            ></v-text-field>
          </div>

        </div>
      </template>

      <template v-if="isSupplier" v-slot:[`item.hasBranch`]="{ item }">
        <div v-if="item.hasBranch">
          <i class="mdi mdi-check-circle success-color"></i>
        </div>
        <div v-else>
          <span>-</span>
        </div>
      </template>

      <template v-slot:[`item.actions`]="{ item }">
       <div>
        <v-tooltip top >
            <template v-slot:activator="{ on,attrs }">
              <v-icon
              small
              class="mr-2"
              @click="brandsModels = true,productid(item)"
              v-bind="attrs"
              v-on="on"
            >
              feather icon-eye
            </v-icon>
            </template>
            <span>{{ $t("Detalle") }}</span>
          </v-tooltip>
          
        <v-tooltip v-if="isUpdate" top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              small
              class="mr-2"
              @click="updateRecord(item)"
              v-bind="attrs"
              v-on="on"
              
            >
              mdi mdi-square-edit-outline
            </v-icon>
          </template>
          <span>{{ $t("table.edit") }}</span>
        </v-tooltip>
      </div>

      </template>
    </v-data-table>

    <ButtonTableComponent v-if="isButton" v-on:excelTable="excelTable" />
          <v-dialog
            v-model="brandsModels"
            transition="dialog-bottom-transition"
            fullscreen
            hide-overlay
          >
              <v-card>
                <v-toolbar dark color="blue-fmedical">
                  <v-toolbar-title class="pt-4">
                    <p class="text-center">
                      <i class="feather icon-package mr-1"></i>
                      {{ $t("Marcas y modelos del producto") }}
                      
                    </p>
                  </v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-toolbar-items>
                    <v-btn icon dark @click="brandsModels = false">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-toolbar-items>
                </v-toolbar>
                <h5 class="card-title mb-1 pa-5">
                  <i class="feather icon-shopping-bag mr-2"> </i>
                  {{$t("Producto")  }}
                </h5>
                <p class="pa-5">{{ $t(this.datos.description) }}</p>
                <div class="col-md-12">
                  <v-data-table
                    :headers="headers2"
                    fixed-header
                    :items="datos"
                    :footer-props="{
                      'items-per-page-text': $t('table.item_table'),
                      'items-per-page-all-text': $t('table.all'),
                      'items-per-page-options': [15, 30, 50, 100],
                    }"
                    :loading-text="$t('table.loading')"
                    :no-data-text="$t('table.no_results_available')"
                    :no-results-text="$t('table.no_results_search')"
                    dense
                  >
                    <template v-slot:top>
                      <div class="row justify-end">
                        <div
                          class="col-sm-12 col-md-6 col-lg-5 col-xl-5 pb-1 pr-6 text-right"
                        >
                        </div>
                      </div>
                    </template>
                  </v-data-table>
                </div>

              </v-card>
          </v-dialog>

    
  </div>
</template>

<script>
import { UtilFront, PermissionConstants } from "@/core";
import ButtonTableComponent from "@/common/table/ButtonTableComponent";
import ProductsView from "../../views/catalogs/ProductsView.vue";
import { ProductsRequest, CategoryRequest, ExcelRequest } from "@/core/request";
import { MODELSBRANDS } from "@/core/DataTableHeadersLocale";
import BrandComponent from "../select/BrandComponent.vue";


export default {
  
  props: {
  
    headers: {},
    isDelete: false,
    isUpdate: false,
    isButton: false,
    isSupplier: false,
    isDetail: false,

  },
  data() {
    return {
      headers2: MODELSBRANDS(),
      brands:[],
      prodbrands:[],
      datos:[
        {
        description:"",
        nameBrand:"",
        nameModels:""
      },
      ],
      nameBrand: [],
      typeProducts: [],
      search: "",
      dataList: [],
      brandsModels:false,
      permissions: PermissionConstants,
      SearchBrand: null,
      searchtypeProduct: null,
      mainlist: [],
      mainListTypeProduct: [],
      description:"",
      filteredProducts: [],
      filteredProductsType: [],
      filterallproducts2:[],
    };
  },
  components: {
    ButtonTableComponent,
    ProductsView,
    ProductsRequest,
    BrandComponent    
  },
  methods: {
    /* General */
      async productid(object) {
      this.model = {
        ...this.model,
        ...object,
      };
      await ProductsRequest.brandbyproduct(
        {
          "idProduct" : this.model.idProduct
        }
      )

      .then((res) => {
        this.prodbrands=res.data.data.objects
          //console.log(this.prodbrands);
    
      this.datos=this.prodbrands
      this.datos.description=this.model.description


        })
        .catch((error) => {
          console.log(error);
          this.alert("internal");
        })
        .finally(() => {
          this.sending = false;
        }); 
      
    },
    

    excelTable() {
      this.$emit("excelTable");
    },
    withPermissionName(namePermission) {
      return UtilFront.withPermissionName(namePermission);
    },
    reloadComponent(dataList,typeProducts) {
      //this.brands = brands;
      //this.typeProducts = typeProducts;
      this.dataList = dataList;
      this.mainlist = [...this.dataList]
      this.mainListTypeProduct = [...this.dataList]
    },
    
    updateRecord(item) {
      this.$emit("updateRecord", item);
    },
    alert(type, message) {
      this.$refs.alertMessageComponent.reloadComponent(type, message);
    },
    async applyFilter() { 

        //filtrado por tipo de producto
        this.mainlist = [...this.dataList]
        
        if (this.searchtypeProduct==null && this.SearchBrand==null){
          this.reloadComponent(this.dataList,this.brands,this.typeProducts)
        }
        if (this.searchtypeProduct!==null && this.SearchBrand==null){
          let filteredProductsType = this.mainlist.filter((product) => {
          return product.typeProduct ==  this.searchtypeProduct;
        });
          this.mainlist=filteredProductsType
        }
        if (this.searchtypeProduct==null && this.SearchBrand!==null){
          let filteredProducts = this.mainlist.filter((product) => {
          return product.brand ==  this.SearchBrand;
          });
          this.mainlist=filteredProducts 
        }
        if(this.searchtypeProduct!==null && this.SearchBrand!==null){
          let filterallproducts = this.mainlist.filter((product) => {
            return product.typeProduct == this.searchtypeProduct 
          });
          filterallproducts = filterallproducts.filter((product) => {
          return product.brand ==  this.SearchBrand
          });
          this.mainlist = filterallproducts
        }
        //console.log(this.brands)
    },
    async listTypeProduct(){
      
      await ProductsRequest.listAllTypeProducts()
        .then((res) => {
          let { data, success } = res.data.data;
          if (success) {
            this.typeProducts = data;
          } else {
            this.typeProduct = [];
          }
        })
        .catch((error) => {
          console.log(error);
          
          this.alert("internal");
        })
        .finally(() => {
          this.sending = false;
        });
      
    },
    
    /*async applyFilterProductType() { 
      await this.listAll();
      let filteredProductsType = this.dataList.filter((product) => {
        return product.typeProduct ==  this.searchtypeProduct;
        });
        this.reloadComponent(filteredProductsType,this.brands,this.typeProducts)
        if (this.searchtypeProduct==null && this.SearchBrand==null){
          //console.log("Primer if")
          this.reloadComponent(this.mainlist,this.brands,this.typeProducts)
        }
        if (this.searchtypeProduct!==null && this.SearchBrand==null){
          console.log("segundo if de type product")
          this.reloadComponent(filteredProductsType,this.brands,this.typeProducts)
        }
      
    },*/

  },
  created(){
    this.listTypeProduct()
    }  
};
</script>

<style scoped>
.success-color {
  color: #4caf50 !important;
  font-size: 22px;
}
</style>
